import script from "./BottomPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomPanel.vue?vue&type=script&setup=true&lang=js"

import "./BottomPanel.vue?vue&type=style&index=0&id=1fbed82c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fbed82c"]])

export default __exports__